import { render, staticRenderFns } from "./CurrentReports.vue?vue&type=template&id=51ac615c&scoped=true&"
import script from "./CurrentReports.vue?vue&type=script&lang=js&"
export * from "./CurrentReports.vue?vue&type=script&lang=js&"
import style0 from "./CurrentReports.vue?vue&type=style&index=0&id=51ac615c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac615c",
  null
  
)

export default component.exports